/**
 * Get user role based on email
 * @param {string} email - User email address
 * @returns {string} - 'admin' or 'grand' or 'user'
 */
export const getUserRole = (email) => {
  if (!email) return 'user';
  
  const emailLower = email.toLowerCase();
  
  if (emailLower.includes('admin')) {
    return 'admin';
  }
  
  if (emailLower.includes('grand')) {
    return 'grand';
  }
  
  return 'user';
};

/**
 * Check if user has access to a route
 * @param {string} path - Route path
 * @param {string} email - User email
 * @returns {boolean} - true if user has access
 */
export const hasRouteAccess = (path, email) => {
  const role = getUserRole(email);
  
  if (role === 'admin') {
    return true;
  }
  
  if (role === 'grand') {
    return path.startsWith('/quiz');
  }
  
  // Default: no access for other users
  return false;
};

/**
 * Get user email from localStorage
 * @returns {string|null} - User email or null
 */
export const getUserEmail = () => {
  return localStorage.getItem('userEmail');
};

/**
 * Get default route for role
 * @param {string} email - User email address
 * @returns {string} - default route
 */
export const getDefaultRoute = (email) => {
  const role = getUserRole(email);

  if (role === 'grand') return '/quiz/view';
  if (role === 'admin') return '/banner/view';
  return '/login';
};

